const smartRewardsAbi = [
	{
		"inputs": [
			{
				"internalType": "contract IERC20[]",
				"name": "_tokens",
				"type": "address[]"
			},
			{
				"internalType": "uint256[]",
				"name": "_subscriptions",
				"type": "uint256[]"
			}
		],
		"name": "subscribeToSmartProfile",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "claimAllCurrentDividends",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			}
		],
		"name": "claimDividends",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
];

export default smartRewardsAbi;
